import _ from 'lodash'
import {createEMLSerdes, type EMLPropertiesMap} from '@wix/wix-eml-serdes'
import type {DecoratedExportFormat, DecorationPluginUtils, EmlExportFormat} from '../../types'

const serdes = createEMLSerdes()

export const exportEml = (
    componentExport: DecoratedExportFormat,
    {nicknameGenerator}: DecorationPluginUtils
): EmlExportFormat => {
    const serdesExport: EMLPropertiesMap = _.omit(componentExport, ['nickToIdentifierMap'])
    const emlExport: EmlExportFormat = {
        structure: serdes.serialize(serdesExport),
        nickToIdentifierMap: nicknameGenerator.getNicknameToIdMap()
    }

    return emlExport
}
